import store from '../../../store';
export default function checkIfCanCreateSuggestion() {
  let scopes = store.getters.userScopes;
  return scopes.includes('suggestions_create');
}
